import { formatDate } from "../utils/format-utils";

import Assignment from "./Assignment";

export default class ServicePlan {
  servicePlanId?: number | null;
  planId?: number | null;
  clientId?: number | null;
  omniSiteId?: number | null;
  programId?: number | null;
  program?: string | null;
  serviceId?: number | null;
  service?: string | null;
  sessionLocationId?: number | null;
  sessionLocation?: string | null;
  createdOn?: Date | null;
  startDate?: Date | null;
  endDate?: Date | null;
  groupSize?: number | null;
  frequency?: number | null;
  durationMinutes?: number | null;
  icdCode?: string | null;
  eiAuthorizationNumber?: string | null;
  unitCount?: number | null;
  isLocationChangeAllowed?: boolean | null;
  psnLanguageId?: number | null;
  assignments?: Assignment[] | null;

  public constructor(params: ServicePlan = {} as ServicePlan) {
    let {
      servicePlanId = 0,
      planId = null,
      clientId = null,
      omniSiteId = null,
      programId = null,
      program = null,
      serviceId = null,
      service = null,
      sessionLocationId = null,
      sessionLocation = null,
      createdOn = null,
      startDate = null,
      endDate = null,
      groupSize = null,
      frequency = null,
      durationMinutes = null,
      icdCode = null,
      eiAuthorizationNumber = null,
      unitCount = null,
      isLocationChangeAllowed = null,
      psnLanguageId = null,
      assignments = null,
    } = params;
    this.servicePlanId = servicePlanId;
    this.planId = planId;
    this.clientId = clientId;
    this.omniSiteId = omniSiteId;
    this.programId = programId;
    this.program = program;
    this.serviceId = serviceId;
    this.service = service;
    this.sessionLocationId = sessionLocationId;
    this.sessionLocation = sessionLocation;
    this.createdOn = createdOn;
    this.startDate = startDate;
    this.endDate = endDate;
    this.groupSize = groupSize;
    this.frequency = frequency;
    this.durationMinutes = durationMinutes;
    this.icdCode = icdCode;
    this.eiAuthorizationNumber = eiAuthorizationNumber;
    this.unitCount = unitCount;
    this.isLocationChangeAllowed = isLocationChangeAllowed;
    this.psnLanguageId = psnLanguageId;
    this.assignments =
      assignments && assignments.map((item) => new Assignment(item));
  }
  get formattedStartDate() {
    return formatDate(this.startDate);
  }
  get formattedEndDate() {
    return formatDate(this.endDate);
  }
  get mandate() {
    if (Boolean(this.frequency) && Boolean(this.durationMinutes))
      return (
        this.frequency + " x " + this.durationMinutes + " : " + this.groupSize
      );
    return "";
  }

  get isSeitOrPend() {
    return this.program && ["SEIT", "CPSE Pendency"].includes(this.program);
  }
  get isRelatedServices() {
    return this.program && ["CPSE Related Services"].includes(this.program);
  }
  get currentAssignments() {
    let today = new Date();
    return (
      this.assignments &&
      this.assignments.filter(
        (x) =>
          !x.isSubstitute &&
          x.approvalStartDate != null &&
          new Date(x.approvalStartDate) <= today &&
          x.approvalEndDate != null &&
          new Date(x.approvalEndDate) >= today &&
          (x.endDate == null || new Date(x.endDate) >= today)
      )
    );
  }
}
